import { Card, CardContent, CircularProgress } from "@mui/material";
import { snack } from "components/Snack/Snack";
import { toCurrencyFormat } from "helpers/utils";
import { useEffect, useState } from "react";
import { MdChat, MdListAlt, MdPayments } from "react-icons/md";
import agentsService from "services/admin/AgentsService";
import withRouter from "hoc/withRouter";
import { FaList } from "react-icons/fa";

const AgentStatsAverageTime = ({ router: { params }, month }) => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(0)
  const [error, setError] = useState(null)

  useEffect(() => {
    loadData()
  }, [month])

  async function loadData() {
    try {
      setLoading(true)
      const { data: result } = await agentsService.getAverageTime({ month })
      console.log(`AgentStatsDialogs:`, result);
      setData(result.averageTime)
    } catch (ex) {
      console.error(`AgentStatsDialogs ex: `, ex)
      snack(ex?.message)
      setError(ex?.message)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return <div className="text-center"><CircularProgress></CircularProgress></div>
  }

  if (error) {
    return <div>{error}</div>
  }

  return (
    <Card style={{ backgroundColor: 'var(--card-background-color)' }} className="stat-card">
      <CardContent>
        <div className="text-center flex flex-col items-center justify-center">
          <MdListAlt size="42" style={{ color: 'rgba(83, 155, 255)' }}></MdListAlt>
          <h5 className="text-info">Среднее время ответа</h5>
          <h5 className="text-info mt-1">{data} секунд</h5>
        </div>
      </CardContent>
    </Card>
  );
};

export default withRouter(AgentStatsAverageTime)
